import { Partner } from "features/settings/importMapping/partner";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

export interface EditAuthCredentialsProps {
    partner: Partner;
    onChange(val: string): void;
    authenticationKey: string;
}

const EditAuthCredentials: React.FC<EditAuthCredentialsProps> = props => {
    switch (props.partner) {
        case Partner.EverAg:
        case Partner.AgTrax:
        case Partner.DTN:
        case Partner.Agris:
        case Partner.Agvance:
        case Partner.AgVision:
        case Partner.AgTech:
            return <UsernamePasswordCredentials onChange={props.onChange} authenticationKey={props.authenticationKey} />
        case Partner.Barchart:
        case Partner.Oakland:
            return <ApiKeyCredentials onChange={props.onChange} authenticationKey={props.authenticationKey} />
        default:
            return <>Unrecognized Import System</>
    }
}

interface SetAuthCredentialsProps {
    authenticationKey: string;
    onChange(val: string): void;
    
}

const UsernamePasswordCredentials: React.FC<SetAuthCredentialsProps> = props => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        props.onChange(username.length === 0 || password.length === 0
            ? ''
            : `${username}:${password}`);
    }, [username, password]);

    useEffect(() => {
        const parts = props.authenticationKey == null
            ? []
            : props.authenticationKey.split(':');

        if (parts.length !== 2) {
            setUsername('');
            setPassword('');
        }
        else {
            setUsername(parts[0]);
            setPassword(parts[1]);
        }

    }, [props.authenticationKey])

    return <div>
        <div>
            <Form.Control 
                placeholder='Username'
                value={username}
                onChange={ev => setUsername(ev.target.value)} />
        </div>
        <div className="mt-2">
            <Form.Control
                type="password"
                placeholder='Password'
                autoComplete='off'
                value={password}
                onChange={ev => setPassword(ev.target.value)} />
        </div>
    </div>;
}

const ApiKeyCredentials: React.FC<SetAuthCredentialsProps> = props => {

    return <div>
        <Form.Control 
            placeholder='API Key'
            value={props.authenticationKey}
            onChange={ev => props.onChange(ev.target.value)} />
    </div>;
}

export interface AuthCredentialsProps {
    partner: Partner;
    onChange(val: string): void;
}

export default EditAuthCredentials;